module.exports = __webpack_public_path__ + "img/electric_reserved_selected.c7e81ef7.svg";